module.exports = __webpack_public_path__ + "media/images/logo_ogp-6dcaffbe924ee0ee4fca17627cfd0f3d.png";